{
  "welcome.title": "Tu hijo tiene mucho que decir",
  "welcome.body": "Responde unas preguntas rápidas y Timo creará un plan personalizado y gratuito para ayudar a tu hijo a encontrar su voz. Toma unos 90 segundos.",
  "welcome.cta": "Empezar ahora",
  "age.question": "¿Cuántos años tiene tu hijo?",
  "age.sub": "Para que Timo haga las preguntas correctas para su etapa.",
  "age.opt.under3": "Menos de 3",
  "age.opt.3-4": "3-4",
  "age.opt.5-6": "5-6",
  "age.opt.7+": "7+",
  "gender.question": "¿Tu hijo es niño o niña?",
  "gender.opt.boy": "Niño",
  "gender.opt.girl": "Niña",
  "name.question": "¿Cómo se llama tu hijo?",
  "name.sub": "O un apodo, para que Timo lo haga más personal.",
  "name.placeholder": "El nombre de tu hijo",
  "words.question": "¿Aproximadamente cuántas palabras puede decir {name}?",
  "words.sub": "Una estimación aproximada está perfecta.",
  "words.opt.0": "0 palabras",
  "words.opt.1-5": "1-5 palabras",
  "words.opt.6-10": "6-10 palabras",
  "words.opt.11-50": "11-50 palabras",
  "words.opt.50+": "50+ palabras",
  "words.opt.unsure": "No estoy seguro",
  "sentences.question": "¿Usa {name} oraciones más largas (4-6 palabras) con una gramática mayormente correcta?",
  "sentences.opt.yes": "Sí",
  "sentences.opt.no": "No",
  "delay_fact.title": "Empezar temprano hace la mayor diferencia",
  "delay_fact.body": "Unos minutos al día con Timo, y {name} lo esperará con ansias.",
  "delay_fact.cta": "Continuar",
  "calc.title": "Creando el perfil de comunicación de {name}",
  "calc.arr.0": "Entendiendo las necesidades de {name}...",
  "calc.arr.1": "Comparando con las etapas de desarrollo...",
  "calc.arr.2": "Eligiendo las actividades correctas...",
  "calc.arr.3": "Casi listo...",
  "calc.review.text": "Mi hijo pasó de un par de palabras a oraciones cortas. Timo hizo que quisiera hablar.",
  "calc.review.author": "Rasa, mamá de un niño de 4 años",
  "score.title": "Perfil de comunicación de {name}",
  "score.arr.0": "Habla",
  "score.arr.1": "Comprensión",
  "score.arr.2": "Conversación",
  "score.arr.3": "Confianza",
  "score.arr.4": "Social",
  "score.cta": "Crear el plan de {name}",
  "voice.question": "Elige la voz de Timo para {name}",
  "voice.sub": "Toca una tarjeta para escuchar una prueba.",
  "email.title": "Crea tu cuenta gratuita",
  "email.sub": "Guarda el plan de {name} y te permite volver a entrar cuando quieras.",
  "conversation.question": "¿Puede {name} mantener una conversación sin mucha ayuda de un adulto?",
  "conversation.opt.yes": "Sí",
  "conversation.opt.no": "No",
  "questions.question": "¿Disfruta {name} haciendo muchas preguntas, como “¿Por qué llueve?”",
  "questions.opt.yes": "Sí",
  "questions.opt.no": "No",
  "find_words.question": "¿A {name} a veces le cuesta encontrar las palabras en el momento?",
  "find_words.opt.yes": "Sí",
  "find_words.opt.no": "No",
  "sounds.question": "¿Qué sonidos puede decir {name} claramente?",
  "sounds.sub": "Toca todos los que apliquen - ayuda a Timo a elegir la práctica correcta.",
  "sounds.opt.p_b": "P, B  (pato, barco)",
  "sounds.opt.m_n": "M, N  (mano, nariz)",
  "sounds.opt.t_d": "T, D  (taza, dedo)",
  "sounds.opt.k_g": "K, G  (casa, gato)",
  "sounds.opt.f_v": "F, V  (foca, vaca)",
  "sounds.opt.s_z": "S, Z  (sol, zapato)",
  "sounds.opt.l": "L  (luna)",
  "sounds.opt.r": "R  (ratón)",
  "sounds.opt.sh_ch": "SH, CH  (show, chico)",
  "therapist.question": "¿Ha sido {name} visto alguna vez por un terapeuta del habla?",
  "therapist.opt.yes": "Sí",
  "therapist.opt.no": "No",
  "diagnosis.question": "¿Ha recibido {name} algún diagnóstico?",
  "diagnosis.sub": "Esto se mantiene privado y solo ayuda a Timo a personalizar la experiencia.",
  "diagnosis.opt.autism": "Autismo / TEA",
  "diagnosis.opt.speech_delay": "Retraso del habla o del lenguaje",
  "diagnosis.opt.adhd": "TDAH",
  "diagnosis.opt.none": "Ningún diagnóstico",
  "diagnosis.opt.prefer_not": "Prefiero no decirlo",
  "social.question": "¿Le resultan difíciles a {name} las situaciones grupales o sociales?",
  "social.opt.yes": "Sí",
  "social.opt.no": "No",
  "goals.question": "¿Cómo puede ayudar más Timo a {name}?",
  "goals.sub": "Elige hasta 3 - esto da forma a todo el plan.",
  "goals.opt.confidence": "Desarrollar confianza al hablar",
  "goals.opt.conversations": "Practicar conversaciones cotidianas",
  "goals.opt.social": "Manejar momentos sociales difíciles",
  "goals.opt.feelings": "Expresar sentimientos de forma saludable",
  "goals.opt.calm": "Mantener la calma al abrumarse",
  "goals.opt.school": "Prepararse para la escuela",
  "topics.question": "Elige los temas favoritos de {name}",
  "topics.sub": "Timo los integra en la práctica.",
  "topics.opt.animals": "Animales",
  "topics.opt.space": "Espacio",
  "topics.opt.vehicles": "Vehículos",
  "topics.opt.music": "Música",
  "topics.opt.nature": "Naturaleza",
  "topics.opt.food": "Comida",
  "experts.title": "Creado con expertos, adaptado a {name}",
  "experts.body": "Timo Helps se guía por un marco de comunicación y autismo, luego se adapta a las respuestas de {name} - nunca es igual para todos.",
  "experts.quote.text": "Más de 10,000 familias usan Timo Helps para ayudar a sus hijos a encontrar su voz.",
  "experts.quote.author": "4.8 de calificación promedio",
  "experts.cta": "Ver el plan de {name}",
  "learn_style.question": "¿Cuál es la forma favorita de aprender de {name}?",
  "learn_style.opt.hands_on": "Hacer actividades manuales",
  "learn_style.opt.stories": "Escuchar cuentos",
  "learn_style.opt.video": "Ver videos",
  "learn_style.opt.games": "Jugar juegos",
  "strengths.question": "¿Cuáles son las fortalezas de {name}?",
  "strengths.sub": "Elige cualquiera que se parezca a tu hijo/a.",
  "strengths.opt.creative": "Creativo",
  "strengths.opt.curious": "Curioso",
  "strengths.opt.caring": "Cariñoso",
  "strengths.opt.determined": "Decidido",
  "strengths.opt.funny": "Divertido",
  "challenge.question": "¿Cuál es el mayor desafío de {name} en este momento?",
  "challenge.opt.frustrated": "Se frustra fácilmente",
  "challenge.opt.distracted": "Se distrae fácilmente",
  "challenge.opt.shy": "Tímido o ansioso con las personas",
  "challenge.opt.overwhelmed": "Se abruma fácilmente",
  "daily_time.question": "¿Cuánto tiempo de práctica te parece realista cada día?",
  "daily_time.sub": "Incluso unos minutos suman rápido.",
  "daily_time.opt.5": "Pequeño impulso",
  "daily_time.hint.5": "5 min al día",
  "daily_time.opt.10": "El tiempo justo",
  "daily_time.hint.10": "10 min al día",
  "daily_time.opt.20": "Super recargado",
  "daily_time.hint.20": "20 min al día",
  "when.question": "¿Cuándo practicará {name}?",
  "when.opt.morning": "Por la mañana",
  "when.hint.morning": "Un comienzo tranquilo",
  "when.opt.afternoon": "Por la tarde",
  "when.hint.afternoon": "Un impulso a mediodía",
  "when.opt.evening": "Por la noche",
  "when.hint.evening": "Calma antes de dormir",
  "who_uses.question": "¿Quién usará Timo Helps con {name}?",
  "who_uses.opt.mom": "Mamá",
  "who_uses.opt.dad": "Papá",
  "who_uses.opt.grandparent": "Abuelo/a",
  "who_uses.opt.specialist": "Un terapeuta o maestro",
  "who_uses.opt.themselves": "Por su cuenta",
  "timeline.question": "¿Qué tan pronto quieres ver progreso?",
  "timeline.opt.weeks": "En unas pocas semanas",
  "timeline.opt.1-2m": "En 1-2 meses",
  "timeline.opt.no_rush": "Sin prisa",
  "main_goal.question": "¿Cuál es tu principal objetivo ahora mismo?",
  "main_goal.opt.catch_up": "Ayudar a {name} a ponerse al día",
  "main_goal.opt.on_track": "Mantener el progreso por buen camino",
  "main_goal.opt.confidence": "Aumentar la confianza de {name}",
  "main_goal.opt.other": "Otra cosa",
  "profile_done.title": "El plan completo de {name} está listo",
  "profile_done.body": "Timo ya tiene todo lo que necesita. Empecemos a practicar juntos.",
  "profile_done.cta": "Empezar a practicar"
}
